export const SET_UI_DATA = "SET_UI_DATA";
